// must mirror DB state
export enum TbaEvaluationMethodEnum {
  CUTCUP = 1,
  RSP,
  CP,
}
